import { render, staticRenderFns } from "./TotalAmountView.vue?vue&type=template&id=31d8236c&scoped=true&"
import script from "./TotalAmountView.vue?vue&type=script&lang=js&"
export * from "./TotalAmountView.vue?vue&type=script&lang=js&"
import style0 from "./TotalAmountView.vue?vue&type=style&index=0&id=31d8236c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d8236c",
  null
  
)

export default component.exports